/**
 * @namespace Pageview
 * @aka PIANO.Pageview
 *
 */
PIANO.Pageview = function (window, document) {

  /**
   *
   * @param {Object} object
   * @return {Object}
   */
  function cleanObject(object) {
    for (var key in object) {
      if (null === object[key] || undefined === object[key]) {
        // Wir müssen das Property auch bei Piano löschen
        window._paq.push(['deleteProperty', key]);
        delete object[key];
      }
    }
    return object
  }

  /**
   *
   */
  var sendPageview = function () {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    /**
     * Add properties to subsequent events
     */
    var properties = {};
    properties['cms'] = 'S';
    properties['content_title'] = document.title;
    properties['content_type'] = (0 !== document.querySelectorAll('article.detail').length ? 'article' : 'website');
    properties['content_description'] = '';
    var contentPublicationDate = ('undefined' !== typeof PIANO.Utils.getPageInformation('firstPublished') ? PIANO.Utils.getPageInformation('firstPublished') : PIANO.Utils.getPageInformation('firstPublished'));
    if ('undefined' !== typeof contentPublicationDate) {
      try {
        var dateObject = new Date(Date.parse(contentPublicationDate));
        contentPublicationDate = dateObject.toISOString();
      } catch (e) {
      }
    }
    properties['refers_to_broadcast'] = (0 !== document.querySelectorAll('aside.broadcastinfo').length) || (0 !== document.querySelectorAll('aside.broadcastfurther').length);
    properties['content_publication_date'] = contentPublicationDate;
    properties['content_id'] = PIANO.Utils.getPageInformation('contentId');
    properties['first_published'] = ('undefined' !== typeof PIANO.Utils.getPageInformation('firstPublished') ? PIANO.Utils.getPageInformation('firstPublished') : PIANO.Utils.getPageInformation('firstPublished'));
    properties['objekttyp'] = PIANO.Utils.getPageInformation('objekttyp');
    properties['page_id'] = PIANO.Utils.getPageInformation('pageId');
    properties['page_producers'] = PIANO.Utils.getPageInformation('pageProducers', [], true);
    var href = document.URL;
    if (-1 !== href.indexOf('~apphtml')) {
      properties['page_render'] = 'apphtml';
    } else if (-1 !== href.indexOf('~embed')) {
      properties['page_render'] = 'embed';
    } else {
      properties['page_render'] = '';
    }
    properties['page_title_html'] = document.title;
    properties['page_topline'] = PIANO.Utils.getPageInformation('pageTopline', '');
    properties['page_categories'] = PIANO.Utils.getPageInformation('pageCategories', [], true);
    properties['event_swr'] = PIANO.Utils.getPageInformation('eventSwr', '');
    properties['user_agent'] = navigator.userAgent;
    properties['redaktion'] = PIANO.Utils.getPageInformation('redaktion', 'keiner Redaktion zugeordnet');
    properties['site_level2'] = PIANO.Utils.getPageInformation('siteLevel2');
    properties['trvd'] = [window._pac.tvrd, PIANO.getVersion()].join('/');
    properties['url'] = PIANO.Utils.getCanonical();

    properties['page'] = PIANO.Utils.getPageInformation('page');
    properties['page_chapter1'] = PIANO.Utils.getPageInformation('pageChapter1');
    properties['page_chapter2'] = PIANO.Utils.getPageInformation('pageChapter2');
    properties['page_chapter3'] = PIANO.Utils.getPageInformation('pageChapter3');

    // Seite ohne link[rel=canonical]
    if ('' === properties['url']) {
      properties['url'] = document.URL;
      properties['page_id'] = encodeURIComponent(properties['url']);
    }

    properties = cleanObject(properties);

    console.debug('Tracking Piano Pageview: setProperties', properties)

    _paq.push(['setProperties', properties, {
      'persistent': true, // Indicates whether the property should be sent on all subsequent events (true) or just the next event sent (false) (default: false)
      'events': ['page.*', 'av.*', 'click.*', 'publisher.*', 'internal_search_result.*'] // Event names the property will be sent on (all events by default)
    }]);

    /**
     * Standard event: Page display
     */
    var data = {}
    data['page'] = PIANO.Utils.getPageInformation('page');
    data['page_chapter1'] = PIANO.Utils.getPageInformation('pageChapter1');
    data['page_chapter2'] = PIANO.Utils.getPageInformation('pageChapter2');
    data['page_chapter3'] = PIANO.Utils.getPageInformation('pageChapter3');

    data = cleanObject(data);

    console.debug('Tracking Piano Pageview: sendEvent, page.display', data)

    _paq.push(['sendEvent', 'page.display', data])
  }

  document.addEventListener('piano:pushstate', function (event) {
    sendPageview();
  });
  document.addEventListener('piano:pageview', function (event) {
    sendPageview();
  });

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {};

}(window, document);

